import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EnvService {
  [key: string]: any;
  public apiUrl = '';
  public enableDebug = false;
  constructor() { }
}
